module.exports = __webpack_public_path__ + "img/northstar-5.e7a9e07d.jpg";